"use strict";
var log = Math.log;
var LN2 = Math.LN2;
module.exports = Math.log2 || function log2(x) {
  return log(x) / LN2;
};
